import { render, staticRenderFns } from "./App.vue?vue&type=template&id=24164ff1&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=24164ff1&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=24164ff1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports